/**
 * MSW Handlers for API mocking
 * 
 * This file contains request handlers for the Mock Service Worker (MSW).
 * Currently, no specific handlers are implemented as they are not required
 * for the current authentication system which relies on cacheKey-based authentication.
 * 
 * Future implementations can add specific handlers here as needed.
 */

// Placeholder handlers array - ready for future implementations
export const handlers: never[] = [
  // Authentication handlers can be added here if needed for development/testing
  // For example:
  // http.get('/api/Account/GetCachedUserInfo', ({ request }) => {
  //   // Mock implementation
  // }),
]

// Export for potential future use
export default handlers
